import React, { createRef, useState } from 'react';
import { observer } from 'mobx-react';
import { Alert } from 'reactstrap';
import {
    FlexDiv,
    Image,
    TextDefault,
    TextLead,
    Heading2,
} from '@awarego-ui/components';
import { ThemedLink } from '../themed/ThemedComponents';

function FaviconUpload({ onFaviconSelected, uploadingFavicon }) {
    const [error, setError] = useState(null);
    const fileRef = createRef();

    const handleFileSelect = (e) => {
        e.stopPropagation();
        e.preventDefault();

        const files = e.target.files || e.dataTransfer.files;
        const file = files[0];
        if (!file) return;

        const allowedTypes = [
            'image/png',
            'image/x-icon',
            'image/vnd.microsoft.icon',
        ];
        if (!allowedTypes.includes(file.type)) {
            setError(`'${file.type}' is not a supported format (PNG or ICO only)`);
            return;
        }
        if (file.size > 100000) {
            setError(`'${file.name}' is too large, max 100KB`);
            return;
        }

        setError(null);
        const formData = new FormData();
        formData.append('image', file);
        onFaviconSelected(formData);
    };

    const handleDragOver = (e) => {
        e.stopPropagation();
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';
    };

    const chooseFile = () => {
        fileRef.current.click();
    };

    return (
        <FlexDiv column alignCenter>
            {error && (
                <FlexDiv mb={16}>
                    <Alert color="danger">{error}</Alert>
                </FlexDiv>
            )}
            <FlexDiv
                onDragOver={handleDragOver}
                onDrop={handleFileSelect}
                column
                padding={80}
                alignCenter
                mb={16}
                border
            >
                <Image
                    src="/static/img/drop-icon.svg"
                    alt="drop your file here"
                    width={50}
                    marginAuto
                />
                {uploadingFavicon ? (
                    <Heading2>Uploading...</Heading2>
                ) : (
                    <FlexDiv column alignCenter>
                        <Heading2>Drag and drop</Heading2>
                        <TextLead>
                            or{' '}
                            <ThemedLink onClick={chooseFile}>browse</ThemedLink>{' '}
                            for an image file
                        </TextLead>
                        <input
                            className="hidden"
                            type="file"
                            multiple={false}
                            accept="image/png,image/x-icon,.ico"
                            onChange={handleFileSelect}
                            ref={fileRef}
                        />
                    </FlexDiv>
                )}
            </FlexDiv>
            <TextDefault>PNG or ICO format, max 100KB</TextDefault>
        </FlexDiv>
    );
}

export default observer(FaviconUpload);
